import { Model as e } from "../../../model.js";
class r extends e {
  constructor(t) {
    super(), this.clientKey = t.clientKey, this.environment = t.environment, this.paymentMethods = t.paymentMethods, this.storedPaymentMethods = t.storedPaymentMethods;
  }
}
export {
  r as AdyenPaymentMethodsResponse
};
//# sourceMappingURL=adyenPaymentMethodsResponse.model.js.map
